import { render, staticRenderFns } from "./ClubOfficialRoster.vue?vue&type=template&id=566ebc44"
import script from "./ClubOfficialRoster.vue?vue&type=script&lang=js"
export * from "./ClubOfficialRoster.vue?vue&type=script&lang=js"
import style0 from "./ClubOfficialRoster.vue?vue&type=style&index=0&id=566ebc44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports